var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.useImage)?_c('img',{staticClass:"logo",attrs:{"src":_vm.getLogoUrl,"alt":_vm.alternativeText},on:{"error":_vm.handleImageError}}):_c('UkaskoGrayIcon',{staticClass:"logo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }